import DeleteModal from '@/components/Modals/DeleteModal';
import { useRefetchPresentersList } from '@/hooks';
import { useDeleteImage } from '@/hooks/useDeleteImage';
import { useAgentEditorStore } from '@/state/root';
import { IPresenter } from '@d-id/types';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

interface Props {
    presenter?: IPresenter;
    onDelete?: () => void;
    onClose?: () => void;
}

const DeleteAvatarModal = observer(({ presenter, onDelete, onClose }: Props) => {
    const agentEditorStore = useAgentEditorStore();

    const { mutateAsync: deleteImage, isLoading: isDeleting } = useDeleteImage(agentEditorStore.selectedPresenterType);
    const { refetchPresentersList } = useRefetchPresentersList();

    const deleteAvatar = useCallback(async () => {
        if (!presenter?.id) {
            return;
        }

        await deleteImage(presenter.id);
        await refetchPresentersList();

        onDelete?.();
    }, [presenter, deleteImage, refetchPresentersList]);

    return (
        <DeleteModal
            itemType="image"
            mode="circle"
            open={!!presenter}
            isLoading={isDeleting}
            onDelete={deleteAvatar}
            onClose={() => onClose?.()}
            poster={presenter?.poster ?? ''}
            text={{
                title: 'Delete this presenter image?',
                content: 'This image will be permanently deleted from your media Library',
                cta: 'Delete image',
            }}
        />
    );
});

export default DeleteAvatarModal;
